<template>
  <div>
    <modal :showDialog="activeModal === 'ADD'" @close="closeModal" :title="$t('ADDREMOTEACCESS')">
      <remote-access-modal @cancel="closeModal" @save="closeModal('getData')" :systemId="systemId"></remote-access-modal>
    </modal>
    <modal :showDialog="activeModal === 'EDIT'" @close="closeModal" :title="$t('ADDREMOTEACCESS')">
      <remote-access-modal @cancel="closeModal" @save="closeModal('getData')" :systemId="systemId"
        :remoteAccessObject="activeRemoteAccess"></remote-access-modal>
    </modal>
    <modal :showDialog="activeModal == 'SELECT_ELEMENT'" @close="closeModal" :title="''">
      <div class="m-4">
        <div class="mb-3">
          {{ $t('SelectElement') }}
        </div>
        <div style="text-align: center;">
          <Button :title="$t('Ok')" buttonClass='save-button semi-bold' style="width: 100px;" @onClick="closeModal"></Button>
        </div>
      </div>
    </modal>
    <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DELETEREMOTEACCESS')">
      <delete-confirm @cancel="closeModal" @confirm="deleteRemoteAccessElement" :text="actionText"></delete-confirm>
    </modal>
    <modal :showDialog="activeModal === 'DELETE_PIN'" @close="closeModal" :title="$t('DELETEREMOTEACCESS')">
      <pin-modal @cancel="closeModal" :text="actionText" @confirm="confirmPinModalAction" :remoteAccessId="activeRemoteAccess != null ? activeRemoteAccess.id : ''" :actionType = "'DELETE'"></pin-modal>
    </modal>
    <modal :showDialog="activeModal === 'SHOW_PASSWORD_PIN'" @close="closeModal" :title="$t('SHOWPASSWORD')">
      <pin-modal @cancel="closeModal" :text="actionText" @confirm="showPassword"
        :remoteAccessId="activeRemoteAccess != null ? activeRemoteAccess.id : ''" :actionType="'SHOW_PASSWORD'"></pin-modal>
    </modal>
    <modal :showDialog="activeModal === 'EDIT_PASSWORD'" @close="closeModal" :title="$t('EDITPASSWORD')">
      <remote-access-password-modal @cancel="closeModal" @save="showPassword" :remoteAccessId="activeRemoteAccess != null ? activeRemoteAccess.id : ''"/>
    </modal>
    <div style="text-align: center; margin: 10px;">
      <span style="font-weight: bold; font-size: 25px;">{{$t('ExternalAccess')}}</span>
      <div style="overflow-x: auto">
        <div style="display: flex; flex-direction: column; flex: 1; height: 100%;">
          <ejs-grid ref="grid" height='100%' width='100%' :toolbar='remoteAccessToolbar'
            :toolbarClick='remoteAccessToolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true"
            :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="remoteAccesses" :allowPaging="false"
            :allowFiltering='false' :allowSorting='true' :allowMultiSorting='true' :showBusyIndicator="true">
            <e-columns>
              <e-column field='platform' :headerText="$t('Platform')" textAlign='Left' :customAttributes="customAttributes"></e-column>
              <e-column field='description' :headerText="$t('Description')" textAlign='Left' :customAttributes="customAttributes"></e-column>
              <e-column field='login' :headerText="$t('Login')" textAlign='Left' :customAttributes="customAttributes"></e-column>
              <e-column field='password' :headerText="$t('Password')" textAlign='Left' :customAttributes="customAttributes" :template="passwordTemplate"></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import { getRemoteAccessForSystem, deleteRemoteAccess } from '@/api/api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'
import Modal from '@/components/Modal.vue'
import RemoteAccessModal from '@/components/Settings/General/RemoteAccessModal.vue';
import RemoteAccessPasswordModal from '@/components/Settings/General/RemoteAccessPasswordModal.vue';
import PinModal from '@/components/Settings/General/PinModal.vue';
import Button from "@/components/Button";
import DeleteConfirm from '@/components/DeleteConfirm.vue'

var context = null

export default {
  props: ['systemId', 'systemName'],
  provide: {
    grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport]
  },
  components: {
    Modal,
    RemoteAccessModal,
    Button,
    DeleteConfirm,
    PinModal,
    RemoteAccessPasswordModal
  },
  data() {
    return {
      wrapSettings: { wrapMode: "Content" },
      selectionOptions: { type: "Multiple" },
      customAttributes: { class: 'customcss' },
      remoteAccesses: [],
      remoteAccessToolbar: [
        { text: this.$t('Add'), tooltipText: this.$t('Add'), prefixIcon: 'e-add', id: 'addRemoteAccess', align: 'Right' },
        { text: this.$t('Edit'), prefixIcon: 'e-edit', id: 'editRemoteAccess', align: 'Right' },
        { text: this.$t('EditPassword'), prefixIcon: 'e-edit', id: 'editPassword', align: 'Right' },
        { text: this.$t('Delete'), prefixIcon: 'e-delete', id: 'deleteRemoteAccess', align: 'Right' },
      ],
      activeModal: 'NONE',
      activeRemoteAccess: null,
      actionText: '',
      passwordTemplate: function () {
        return {
          template: Vue.component('passwordTemplate', {
            template: `
              <button v-if="data.password == null" class='show-password-button' style="align-self: center;" v-on:click="onClick('showPassword')">{{ $t('Show') }}</button>
              <div v-else class="horizontal">
                <div v-on:click="onClick('togglePassword')" style="cursor: pointer; place-self: center;">
                  <svg v-if="passwordToggled" width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.2678 14.2902L24.4743 14.0001L24.2678 13.7101C24.1434 13.5355 23.9811 13.3362 23.791 13.1257C23.2029 12.4743 22.4049 11.7713 21.5072 11.1348C21.4562 11.0986 21.4049 11.0627 21.3536 11.0271L22.0369 10.3438C22.945 10.9715 23.7084 11.6356 24.2566 12.2654C24.8894 12.9922 25.1667 13.5941 25.1667 14.0001C25.1667 14.4183 24.8728 15.0417 24.2065 15.7919C23.5598 16.52 22.6309 17.2901 21.5284 17.9943C19.3149 19.4082 16.4916 20.5001 14 20.5001C13.3762 20.5001 12.7298 20.4317 12.0749 20.3057L12.9442 19.4365C13.2957 19.4721 13.6479 19.4905 14 19.4905C16.6064 19.4905 19.2201 18.4871 21.5072 16.8655C22.4049 16.229 23.2029 15.526 23.791 14.8746C23.9811 14.6641 24.1434 14.4648 24.2678 14.2902ZM3.7323 13.7101L3.52578 14.0001L3.7323 14.2902C3.85664 14.4648 4.01899 14.6641 4.20904 14.8746C4.79715 15.526 5.59518 16.229 6.49287 16.8655C6.54566 16.9029 6.59862 16.94 6.65174 16.9768L5.96842 17.6601C5.05881 17.0319 4.29413 16.3671 3.74497 15.7366C3.11116 15.0091 2.83337 14.4066 2.83337 14.0001C2.83337 13.5819 3.12727 12.9585 3.79356 12.2084C4.44029 11.4803 5.36921 10.7101 6.4717 10.0059C8.68523 8.59204 11.5085 7.50013 14 7.50013C14.6262 7.50013 15.2752 7.5691 15.9325 7.69596L15.0639 8.56462C14.7097 8.5284 14.3548 8.50979 14 8.50979C11.3937 8.50979 8.77994 9.51312 6.49287 11.1348C5.59518 11.7713 4.79715 12.4743 4.20904 13.1257C4.01899 13.3362 3.85664 13.5355 3.7323 13.7101ZM14.9151 17.4656L17.4655 14.9152C17.138 16.1588 16.1587 17.1381 14.9151 17.4656ZM13.0969 10.5316L10.5315 13.097C10.8569 11.8437 11.8436 10.857 13.0969 10.5316ZM5.60867 21.949L22.1855 5.37221C22.3321 5.22554 22.5699 5.22554 22.7166 5.37221C22.8633 5.51887 22.8633 5.75666 22.7166 5.90333L6.13979 22.4801C5.99312 22.6268 5.75533 22.6268 5.60867 22.4801C5.462 22.3335 5.462 22.0957 5.60867 21.949Z" fill="#F2F2F2" stroke="#333333"/></svg>
                  <svg v-else width="25" height="25" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14 21C8.76228 21 2.33337 16.4416 2.33337 14C2.33337 11.5584 8.76228 7 14 7C19.2378 7 25.6667 11.5584 25.6667 14C25.6667 16.4416 19.2378 21 14 21ZM4.58016 14.5394C5.14014 15.1596 5.90958 15.8388 6.78207 16.4575C9.00619 18.0345 11.5209 18.9903 14 18.9903C16.4791 18.9903 18.9939 18.0345 21.218 16.4575C22.0905 15.8388 22.8599 15.1596 23.4199 14.5394C23.6006 14.3392 23.75 14.1551 23.8605 14C23.75 13.8449 23.6006 13.6608 23.4199 13.4606C22.8599 12.8404 22.0905 12.1612 21.218 11.5425C18.9939 9.9655 16.4791 9.00966 14 9.00966C11.5209 9.00966 9.00619 9.9655 6.78207 11.5425C5.90958 12.1612 5.14014 12.8404 4.58016 13.4606C4.39946 13.6608 4.25004 13.8449 4.13959 14C4.25004 14.1551 4.39946 14.3392 4.58016 14.5394ZM14 18.0833C11.7449 18.0833 9.91671 16.2552 9.91671 14C9.91671 11.7448 11.7449 9.91667 14 9.91667C16.2552 9.91667 18.0834 11.7448 18.0834 14C18.0834 16.2552 16.2552 18.0833 14 18.0833ZM14 15.9833C15.0954 15.9833 15.9834 15.0954 15.9834 14C15.9834 12.9046 15.0954 12.0167 14 12.0167C12.9047 12.0167 12.0167 12.9046 12.0167 14C12.0167 15.0954 12.9047 15.9833 14 15.9833Z" fill="#333333"/></svg>
                </div>
                <div v-on:click="onClick('copyPassword')" style="cursor: pointer; place-self: center; margin-left: 3px;" :style="[passwordToggled ? {'-webkit-text-security': 'disc'}: {'-webkit-text-security': 'none'}]">{{data.password}}</div>
              </div>
            `,
            data: function () {
              return {
                data: {},
                passwordToggled: true,
              }
            },
            computed: {
            },
            methods: {
              onClick(mode) {
                switch (mode) {
                  case 'showPassword':
                    context.actionText = this.$t('ShowPassword') +' ' + this.data.platform + ' - ' + this.data.description
                    context.openModal(this.data, 'SHOW_PASSWORD_PIN');
                    break;
                  case 'copyPassword':
                    navigator.clipboard.writeText(this.data.password);
                    break;
                  case 'togglePassword':
                    this.passwordToggled = !this.passwordToggled
                    break;
                }
              }
            }
          })
        }
      },
    }
  },
  methods: {
    async getData() {
      this.$emit('spin', true)
      var oldData = this.remoteAccesses;
      this.remoteAccesses = await getRemoteAccessForSystem(this.systemId);

      if (oldData == null) {
        this.remoteAccesses.forEach((s) => {
          s.pin = null;
          s.password = null;
        })
      } else {
        this.remoteAccesses.forEach((s) => {
          var oldObject = oldData.find(x => x.id == s.id);
          if (oldObject != null && oldObject.pin != null) {
            s.pin = oldObject.pin;
            s.password = oldObject.password;
          } else {
            s.pin = null;
            s.password = null;
          }
        })
      }
      this.$emit('spin', false)
    },
    dataBound: function () {
      this.$refs.grid.autoFitColumns();
    },
    remoteAccessToolbarClick: function (args) {
      switch (args.item.id) {
        case 'addRemoteAccess':
          this.openModal(null, 'ADD')
          break;
        case 'editRemoteAccess':
          let rows = this.$refs.grid.getSelectedRecords();

          if (rows.length > 0) {
            this.openModal(rows[0], 'EDIT')
          } else {
            this.openModal(null, 'SELECT_ELEMENT');
          }
          break;
        case 'editPassword':
          let row = this.$refs.grid.getSelectedRecords();
          if (row.length > 0) {
            this.actionText = this.$t('EditPassword') + ' ' + row[0].platform + ' - ' + row[0].description;

            this.openModal(row[0], 'EDIT_PASSWORD')
          } else {
            this.openModal(null, 'SELECT_ELEMENT');
          }
          break;
        case 'deleteRemoteAccess':
          let rowsSelected = this.$refs.grid.getSelectedRecords();

          if (rowsSelected.length > 0) {
            this.actionText = this.$t('Delete') + ' ' + rowsSelected[0].platform + ' - ' + rowsSelected[0].description;

            if (rowsSelected[0].pin != null) {
              this.openModal(rowsSelected[0], 'DELETE')
            } else {
              this.openModal(rowsSelected[0], 'DELETE_PIN')
            }
          } else {
            this.openModal(null, 'SELECT_ELEMENT');
          }
          break;
      }
    },
    openModal(remoteAccess, mode) {
      this.activeRemoteAccess = remoteAccess;
      this.activeModal = mode;
    },
    closeModal(mode) {
      this.activeRemoteAccess = null;
      this.activeModal = 'NONE';
      this.actionText = '';
      if (mode == 'getData')
        this.getData()
    },
    async deleteRemoteAccessElement() {
      await deleteRemoteAccess(this.activeRemoteAccess.id, this.activeRemoteAccess.pin)
      this.closeModal('getData')
    },
    async confirmPinModalAction(pin) {
      this.remoteAccesses.forEach((s) => {
        if (s.id == this.activeRemoteAccess.id) {
          s.pin = pin;
        }
      })

      this.closeModal('getData')
    },
    showPassword(pin, password) {
      this.remoteAccesses.forEach((s) => {
        if (s.id == this.activeRemoteAccess.id) {
          s.pin = pin != null ? pin : s.pin;
          s.password = password != null ? password : s.password;
        }
      });
      this.closeModal('getData');
    },
  },
  mounted: async function () {
    context = this

    await this.getData();
  },
}
</script>
<style scoped>
.table {
  border-top: none;
  border-left: none;
  border-right: none;
}

.table tbody {
  border-left: 1px solid #A3D4E0;
  border-right: 1px solid #A3D4E0;
}

.e-grid .e-headercell.customcss {
  padding: 0 5px 0 5px;
}

.e-grid .e-headercell .e-headercelldiv {
  padding-right: 5px;
}

.e-gridchkbox.customcss .e-checkbox-wrapper {
  vertical-align: middle;
}

#photos-container {
  width: 100%;
  height: 100%;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  width: 4%;
  height: 0;
  padding-bottom: 4%;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

.photo {
  margin: 0 auto 0 auto;
  border-radius: 4px;
  object-fit: contain;
  width: 88%;
  height: 100%;
}

.thumbnails {
  overflow-y: hidden;
  overflow-x: scroll;
  max-width: 80%;
  margin: 0 auto 0 auto;
}

.thumbnail {
  width: 64px;
  height: 64px;
  margin: 5px;
  object-fit: cover;
  cursor: pointer;
  background: #34758E;
  border-radius: 4px;
}

#map {
  height: 100%;
  width: 100%;
  background: white;
  border-radius: 5px;
}

.info-field {
  border-bottom: 1px solid #E9E9E9;
  margin-bottom: 12px;
  margin-top: 12px;
}

.info-field-row {
  width: 100%;
  margin: 0;
  padding-bottom: 5px;
}

.info-field-value {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: #272727;
}

.info-field-title {
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 16px;
  color: #272727;
}


</style>
<style>
/* .tippy-tooltip.customTheme-theme {
  background-color: #346F8B;
}

.tippy-popper[x-placement^='left'] .tippy-tooltip.customTheme-theme .tippy-arrow {
  border-left: 8px solid #346F8B;
} */
.show-password-button {
  border: 1px #ddd solid;
  padding: 5px 10px;
  background: none;
}

.show-password-button:hover {
  background: #bbbbbb;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings/General/RemoteAccess.vue